<app-loading-modal
	[visible]="isLoading"
	[message]="message"
></app-loading-modal>
<!-- Timeline / Editor de Reel -->
<div class="timeline-section card shadow-sm border-0 p-3 mb-4">
	<!-- Header de la tarjeta -->
	<div
		class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2"
	>
		<h5
			class="mb-0 fw-semibold text-primary fs-5 d-flex align-items-center"
		>
			<i class="pi pi-list me-2 fs-4 margen"></i>
			Gestor de campañas
		</h5>
		<h5 class="mb-0 fw-semibold fs-5 d-flex align-items-center">
			{{ selectedReelName }}
		</h5>

		<div class="d-flex gap-2">
			<button
				*ngIf="selectedReelId"
				pButton
				type="button"
				label="Info de Campaña"
				icon="pi pi-pencil"
				class="p-button-sm p-button-success margen-button"
				(click)="edit_reel()"
			></button>
			<button
				pButton
				type="button"
				label="Guardar"
				icon="pi pi-save"
				class="p-button-sm p-button-primary margen-button"
				(click)="saveTimeline()"
			></button>

			<button
				pButton
				type="button"
				label="Cancelar"
				icon="pi pi-times"
				class="p-button-sm p-button-outlined p-button-danger margen-button"
				(click)="cancelTimeline()"
			></button>
		</div>
	</div>

	<!-- Contenido dividido en 2 columnas -->
	<div class="row g-3">
		<!-- IZQUIERDA: Collage de reels guardados en grid -->
		<div class="col-12 col-md-3">
			<div class="border rounded bg-light p-2 h-100 d-flex flex-column">
				<div
					class="d-flex align-items-center justify-content-between mb-2"
				>
					<span
						class="text-muted text-uppercase small fw-bold d-flex align-items-center"
					>
						<i class="pi pi-folder-open me-1 text-primary"></i>
						Campañas guardadas
					</span>

					<button
						*ngIf="canAddGroup"
						pButton
						type="button"
						icon="pi pi-plus"
						class="p-button-text p-button-rounded p-button-sm"
						title="Nuevo reel"
						(click)="createNewReel()"
					></button>
				</div>

				<!-- GRID -->
				<div
					class="reels-grid"
					style="
						display: grid;
						grid-template-columns: repeat(
							auto-fill,
							minmax(120px, 1fr)
						);
						gap: 0.75rem;
						max-height: 260px;
						overflow-y: auto;
						padding-right: 0.5rem;
					"
				>
					<div
						class="reel-card card border-0 shadow-sm cursor-pointer"
						*ngFor="let r of ReelsByUser"
						(click)="selectReel(r)"
						[class.reel-disabled]="!isDisabled(r)"
						style="transition: all 0.15s ease"
					>
						<div class="card-body p-2">
							<!-- Mini collage preview 2x2 -->
							<div
								class="rounded overflow-hidden border mb-2"
								style="
									width: 100%;
									height: 70px;
									background-color: #000;
									display: grid;
									grid-template-columns: 1fr 1fr;
									grid-template-rows: 1fr 1fr;
									gap: 1px;
								"
							>
								<img
									*ngFor="let t of r.medias | slice: 0 : 4"
									[src]="
										t.type == 'VIDEO'
											? t.thumb_url
											: t.resource_url
									"
									class="w-100 h-100"
									style="object-fit: cover"
								/>
							</div>

							<!-- Nombre + cantidad -->
							<div
								class="d-flex align-items-start justify-content-between"
							>
								<div
									class="fw-semibold text-truncate"
									style="font-size: 0.8rem; max-width: 90px"
									[title]="r.name"
								>
									{{ r.name }}
								</div>

								<span
									class="badge bg-primary text-white ms-2"
									style="font-size: 0.7rem"
								>
									{{ r.medias?.length || 0 }}
								</span>
							</div>

							<!-- Descripción corta -->
							<div
								class="text-muted text-truncate"
								style="font-size: 0.7rem; max-width: 100%"
								[title]="r.descripcion || 'Sin descripción'"
							>
								{{ r.totalDuration || "Sin descripción" }}
							</div>
						</div>
					</div>
				</div>

				<!-- Nota inferior -->
				<div class="mt-2 text-center">
					<small class="text-muted d-block" style="font-size: 0.7rem">
						Toca una campaña para cargarla en la línea de tiempo.
					</small>
				</div>
			</div>
		</div>

		<!-- Columna derecha: editor del reel -->
		<div class="col-12 col-md-9">
			<!-- Contenedor general del editor -->
			<div
				class="timeline-wrapper p-2 p-md-3 bg-light rounded border h-100"
			>
				<!-- Encabezado del editor -->
				<div class="timeline-header-responsive mb-3">
					<div class="timeline-header-title">
						<span class="fw-semibold">Línea de tiempo</span>
					</div>

					<div class="caja-buttons d-flex align-items-center gap-3 flex-wrap">
						<button
							type="button"
							class="btn btn-sm btn-outline-danger"
							(click)="removeAllFromTimeline()"
							[disabled]="reelTimeline.length === 0"
						>
							<i class="pi pi-times-circle"></i>
							Limpiar
						</button>
						<button
							type="button"
							class="btn btn-sm btn-outline-danger"
							(click)="removeExpiredFromTimeline()"
							[disabled]="!hasExpiredItems()"
						>
							<i class="pi pi-trash me-1"></i>
							Eliminar vencidos
						</button>

						<div
							class="timeline-duration-box"
							*ngIf="totalDurationSelected"
						>
							<strong>Duración total:</strong>
							<span>{{ totalDurationSelected }}</span>
						</div>
					</div>
				</div>

				<!-- Zona de drop del timeline -->
				<div
					class="timeline-dropzone-responsive"
					cdkDropList
					#timelineList="cdkDropList"
					cdkDropListOrientation="horizontal"
					[cdkDropListData]="reelTimeline"
					[cdkDropListConnectedTo]="[repertorioList]"
					(cdkDropListDropped)="onDropTimeline($event)"
				>
					<!-- Mensaje cuando no hay elementos -->
					<div
						*ngIf="!reelTimeline || reelTimeline.length === 0"
						class="drop-hint"
					>
						<i class="pi pi-arrow-right-arrow-left mb-2"></i>
						Suelta aquí los videos del repertorio
					</div>

					<!-- Items del timeline -->
					<div
						class="timeline-item-responsive card border-0 shadow-sm p-2 text-center flex-shrink-0 position-relative"
						*ngFor="let clip of reelTimeline; let i = index"
						cdkDrag
						[cdkDragData]="clip"
						[cdkDragDisabled]="!puedeArrastrarMedia(clip)"
						[class.drag-disabled]="!puedeArrastrarMedia(clip)"
					>
						<button
							type="button"
							class="timeline-remove-btn"
							(click)="
								removeFromTimeline(i, clip);
								$event.stopPropagation()
							"
						>
							<i class="pi pi-times"></i>
						</button>

						<div class="thumb mb-2">
							<img
								[src]="
									clip.type === 'VIDEO'
										? clip.thumb_url
										: clip.resource_url
								"
								[alt]="clip.name"
								class="img-fluid rounded timeline-thumb-responsive"
							/>
						</div>

						<div
							class="label-disabled mb-2"
							*ngIf="!puedeArrastrarMedia(clip)"
						>
							Vencido
						</div>

						<div class="meta small mb-2">
							<div
								class="fw-semibold text-truncate"
								[title]="clip.name"
							>
								{{ clip.name }}
							</div>
						</div>

						<!-- Footer con posición y duración -->
						<div
							class="d-flex justify-content-between align-items-center mt-auto px-1"
						>
							<!-- Posición -->
							<div class="badge bg-blue text-white px-2 py-1">
								#{{ i + 1 }}
							</div>

							<!-- Duración -->
							<div
								class="badge bg-light text-dark border px-2 py-1"
							>
								{{ formatDuration(clip.duration_seconds) }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Repertorio -->
<div class="repertorio-section card shadow-sm border-0 p-3">
	<div class="encabezado d-flex">
		<h6 class="mb-3 fw-semibold text-primary align-items-center">
			<i class="pi pi-video me-1"></i>
			Repertorio disponible
		</h6>
		<!-- Botón para crear nueva media -->
		<button
			pButton
			type="button"
			icon="pi pi-plus"
			class="ms-auto p-button-sm p-button-rounded p-button-outlined"
			label="Nueva media"
			(click)="createNewMedia()"
		></button>
	</div>

	<!-- Buscador -->
	<div
		class="header-filtro d-flex align-items-center justify-content-between mb-3 gap-3"
	>
		<!-- Filtro de vigencia -->
		<div class="d-flex align-items-center gap-2">
			<p-inputSwitch
				[(ngModel)]="soloVigentes"
				(ngModelChange)="filterRepertorio()"
			></p-inputSwitch>
			<span class="fw-Bold margen"> Solo vigentes</span>
		</div>

		<!-- Buscador -->
		<div class="input-group input-group-sm w-50">
			<span class="input-group-text bg-light border-0">
				<i class="pi pi-search text-primary"></i>
			</span>
			<input
				type="text"
				class="form-control border-0 shadow-sm"
				placeholder="Buscar media..."
				[(ngModel)]="searchTerm"
				(input)="filterRepertorio()"
			/>
		</div>
	</div>

	<div
		class="repertorio-wrapper d-flex flex-wrap gap-3"
		cdkDropList
		#repertorioList="cdkDropList"
		[cdkDropListData]="repertorio"
		[cdkDropListConnectedTo]="[timelineList]"
		(cdkDropListDropped)="onDropRepertorio($event)"
	>
		<app-loading-modal
			[visible]="isLoadingRepertorio"
			[message]="'Cargando medias...'"
		></app-loading-modal>
		<div *ngIf="!repertorio || repertorio.length === 0" class="drop-hint">
			<i class="pi pi-arrow-right-arrow-left mb-2"></i>
			Al seleccionar un Reel, se desplegarán las medias coincidentes con
			el tipo de reel.
		</div>
		<div
			class="repertorio-item card p-2 text-center border-0 shadow-sm flex-shrink-0"
			*ngFor="let media of repertorio"
			cdkDrag
			[cdkDragData]="media"
			[cdkDragDisabled]="!puedeArrastrarMedia(media)"
			[class.drag-disabled]="!puedeArrastrarMedia(media)"
			style="width: 150px; height: 150px"
		>
			<div class="thumb mb-2">
				<img
					[src]="
						media.type == 'VIDEO'
							? media.thumb_url
							: media.resource_url
					"
					[alt]="media.name"
					class="img-fluid rounded"
					style="height: 100px; width: 100%; object-fit: cover"
				/>
			</div>
			<div class="label-disabled" *ngIf="!puedeArrastrarMedia(media)">
				Vencido
			</div>
			<div class="label small fw-semibold text-truncate">
				{{ media.name }}
			</div>
		</div>
	</div>
</div>
